export const CLICK_MODAL_BACKDROP = '[EXPORT] CLICK_MODAL_BACKDROP';
export const FINISH_EXPORT_REQUESTING = '[EXPORT] FINISH_EXPORT_REQUESTING';

export default {
    CLICK_MODAL_BACKDROP,
    FINISH_EXPORT_REQUESTING
}


// WEBPACK FOOTER //
// ./src/view/constant/ExportDataPopupConstant.js